<template>
  <div class="toxic-container">
    <p>Toxique</p>
    <button @click="chooseToxicity(true)">Oui</button>
    <button @click="chooseToxicity(false)">Non</button>
  </div>
</template>

<script>
export default {
  name: "toxicity",
  methods: {
    chooseToxicity(value) {
      this.$emit("getToxicity", value);
    },
  },
};
</script>

<style>
</style>